<template>
  <div class="mstabsdetails row m-0 global__scrollbar">
    <div class="mstabsdetails__tab">
      <div>
        <div class="mstabsdetails__tab--icon mb-2"
        :class="`${item.name === tabSelected ? 'icon-selected' : ''} ${detail.freightMode === 'OCEAN' ? 'bc_blue' : detail.freightMode === 'AIR' ? 'bc_purple' : '' }`"
        :id="`msdetail-icon-${i}`" @click="chooseTab(item)"
        v-for="(item, i) in iconList" :key="i">
          <img :src="item.image" alt="">
          <b-tooltip id="tabs_detail" :custom-class="`${detail.freightMode === 'OCEAN' ? 'global__bc_blue' : 'global__bc_purple'}`" :target="`msdetail-icon-${i}`"
          :delay="{ show: 400, hide: 50 }" placement="righttop">
            {{ item.name }}
          </b-tooltip>
        </div>
      </div>
    </div>
    <keep-alive>
      <component
       :is="componentSelected"
       :canEdit="canEdit"
       @chooseEdit="chooseEdit"
        >
      </component>
    </keep-alive>
  </div>
</template>

<script>
import OrderInformation from './tab-detail/OrderInformation.vue'
import ShipperDetails from './tab-detail/ShipperDetails.vue'
import ConsigneeDetails from './tab-detail/ConsigneeDetails.vue'
import CommodityDetails from './tab-detail/CommodityDetails.vue'
import CarrierInformation from './tab-detail/CarrierInformation.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DetailsAirOcean',
  components: {
    OrderInformation,
    ShipperDetails,
    ConsigneeDetails,
    CommodityDetails,
    CarrierInformation
  },
  data () {
    return {
      tabSelected: 'Order Information',
      componentSelected: OrderInformation,
      canEdit: false,
      shipmentId: this.$route.params.shipmentId,
      orderNumber: this.$route.params.orderNumber,
      currentChooseSection: '',
      detailContent: {
        title: 'Order Information'
      },
      iconList: [
        {
          name: 'Order Information',
          image: require('@/assets/image/icon/msdetail_order_info.svg'),
          component: OrderInformation
        },
        {
          name: 'Shipper Details',
          image: require('@/assets/image/icon/msdetail_shipper.svg'),
          component: ShipperDetails
        },
        {
          name: 'Consignee Details',
          image: require('@/assets/image/icon/msdetail_consignee.svg'),
          component: ConsigneeDetails
        },
        {
          name: 'Commodity Details',
          image: require('@/assets/image/icon/msdetail_commodity.svg'),
          component: CommodityDetails
        },
        {
          name: 'Carrier Information',
          image: require('@/assets/image/icon/msdetail_carrier.svg'),
          component: CarrierInformation
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',
      profile: 'auth/profile'
    })
  },
  created () {
    this.$eventHub.$on('catch-confrim-edit-MS', this.catchConfirmEdit)
  },
  beforeDestroy () {
    this.$eventHub.$off('catch-confrim-edit-MS')
  },
  methods: {
    chooseEdit (data) {
      this.canEdit = data
    },
    chooseTab (item) {
      this.currentChooseSection = item
      if (!this.canEdit && (this.tabSelected !== item.name)) {
        this.tabSelected = item.name
        this.componentSelected = item.component
      } else if (this.canEdit && (this.tabSelected !== item.name)) {
        this.$eventHub.$emit('dialog-confirm-edit-ms')
      }
    },
    catchConfirmEdit (leaving) {
      if (leaving) {
        this.canEdit = false
        this.$eventHub.$emit('reset-data')
        this.chooseTab(this.currentChooseSection)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/DetailsAirOcean.vue